import React, { useState } from 'react';

export default (WrappedComponent) => {
  return (props) => {
    const [itemId, setItemId] = useState(null);

    const currentActiveMenuItem = (id) => {
      setItemId(id);
    };

    return (
      <WrappedComponent
        {...props}
        currentActiveId={itemId}
        currentActiveMenuItem={(id) => currentActiveMenuItem(id)}
      />
    );
  };
};

export function equalSectionIdsOnPageLoad(id) {
  if (typeof window !== 'undefined') {
    return window.location.hash === '#' + id;
  }
}
